import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsAffinitypublisherComponent } from './simple-icons-affinitypublisher.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsAffinitypublisherComponent ],
    exports:      [ SimpleIconsAffinitypublisherComponent ],
    bootstrap:    []
})
export class SimpleIconsAffinitypublisherModule {}
